;(function () {
  'use strict'

  angular.module('deskfy.arts').controller('PublicDownloadController', PublicDownloadController)

  /* @ngInject */
  function PublicDownloadController (
    $scope,
    $state,
    $rootScope,
    $translate,
    $q,
    $sce,
    ShareLinkService,
    ToastService,
    UdsModalService,
    Utils,
    CONSTANTS
  ) {
    const getDownloadDialogController = () => $q.when(import('../../dialogs/download/download-dialog.controller'))

    $scope.loading = true

    const api = {
      getDownloadDialogController,
      _successGetLinkInfo,
      _errorGetLinkInfo
    }
    this.getApi = () => api

    activate()

    function activate () {
      $scope.uuid = $state.params.uuid
      ShareLinkService.getShareLinkArt($scope.uuid)
        .then(api._successGetLinkInfo)
        .catch(api._errorGetLinkInfo)
        .finally(() => {
          $scope.loading = false
        })
    }

    function _successGetLinkInfo (link) {
      $scope.link = link
      if ($scope.link.comment) {
        $scope.link.comment = $sce.trustAsHtml($scope.link.comment)
      }
    }

    function _errorGetLinkInfo ({ data }) {
      if (data.code === 'EXPIRED') {
        $scope.isExpired = true
        $scope.link = {
          art: {
            name: data.data.artName
          }
        }
      }
    }

    $scope.downloadArt = function () {
      if ($scope.link.art.needApproval && $scope.link.art.approvalStatus !== 'APPROVED' && $rootScope.isUser()) {
        ToastService.showErrorToast($translate.instant('pendingApprovalErrorMsg'))
        return
      }

      if ($scope.link.art.downloadOption.includes('MP4')) {
        $scope.link.art.extension = 'mp4'
        return ShareLinkService.downloadArt($scope.uuid, $scope.link.art)
      }

      if ($scope.link.art.isCustomizable) {
        api.getDownloadDialogController().then(({ DownloadDialogController }) => {
          const downloadDialog = UdsModalService.createModal({
            controller: DownloadDialogController,
            modalName: 'downloadDialog',
            data: {
              _iArtId: $scope.link.art.id,
              _sDownloadOption: $scope.link.art.downloadOption,
              _customizationLevel: $scope.link.art.customizationLevel,
              _isCustomizable: $scope.link.art.isCustomizable,
              _iProductId: $scope.link.art.productId,
              _uuid: $scope.uuid,
              _oTemplate: $scope.link.art,
              publicDownload: true
            }
          })

          downloadDialog.open()
        })
      } else {
        const url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_SHARE_LINK_ID_DOWNLOAD, [$scope.uuid])
        return Utils.downloadFile(url)
      }
    }
  }
})()
